import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import {
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  Box,
  Typography,
} from '@mui/material'
import React, { useImperativeHandle, useState } from 'react'
import TableItemMoreMenu from './TableItemMoreMenu'
import { useEffect } from 'react'
import { useTheme } from '@emotion/react'
import GroupCollapse from './GroupCollapse'
import { useTranslation } from 'react-i18next'

const Row = React.forwardRef((props: any, ref) => {
  const {
    isItemSelected,
    checkbox,
    handleCheckboxClick,
    id,
    headers,
    rowIndex,
    getElement,
    row,
    groupItems,
    rowActions,
    collapsable,
    collapseComponent,
    defaultRowActions,
    onRowDelete,
    onRowEdit,
  } = props

  const [open, setOpen] = useState(false)
  const [insideRow, setInsideRow] = useState(row)
  const theme = useTheme() as any
  const { t } = useTranslation()

  useImperativeHandle(ref, () => ({
    handleOpen(value: boolean) {
      setOpen(value)
    },
  }))

  useEffect(() => {
    setInsideRow(row)
  }, [row])

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        selected={isItemSelected}
        aria-checked={isItemSelected}
      >
        {checkbox && (
          <TableCell padding="checkbox">
            <Checkbox
              checked={isItemSelected}
              onChange={(event) => handleCheckboxClick(event, id)}
            />
          </TableCell>
        )}
        {collapsable && (
          <TableCell>
            <IconButton
              size="small"
              onClick={() => {
                setOpen(!open)
              }}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
        )}

        {groupItems?.length > 0 && (
          <TableCell
            onClick={() => {
              setOpen(!open)
            }}
            sx={{ p: 2, cursor: 'pointer' }}
            colSpan={12}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton size="small">
                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
              <Typography sx={{ ml: 2 }} variant="h6">
                {t(insideRow?.category)} : {insideRow?.key}
              </Typography>
            </Box>
          </TableCell>
        )}

        {!groupItems?.length &&
          headers?.map((rowElement: any, index: any) =>
            getElement(rowElement, index, insideRow),
          )}

        {!groupItems?.length && (
          <TableCell align="right">
            <TableItemMoreMenu
              setInsideRow={setInsideRow}
              row={insideRow}
              rowIndex={rowIndex}
              rowActions={rowActions}
              defaultRowActions={defaultRowActions}
              onRowEdit={onRowEdit}
              onRowDelete={onRowDelete}
            />
          </TableCell>
        )}
      </TableRow>
      {collapsable && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              {collapseComponent && collapseComponent(insideRow)}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
      {groupItems?.length > 0 && (
        <GroupCollapse
          open={open}
          headers={headers}
          insideRow={insideRow}
          getElement={getElement}
          setInsideRow={setInsideRow}
          rowActions={rowActions}
          onRowEdit={onRowEdit}
          onRowDelete={onRowDelete}
          defaultRowActions={defaultRowActions}
        />
      )}
    </>
  )
})

export default Row
